import { z } from 'zod';

export const TASK_STATUSES = ['todo', 'in_progress', 'blocked', 'done', 'cancelled'] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

export const TASK_PRIORITIES = ['low', 'normal', 'high', 'urgent'] as const;
export type TaskPriority = (typeof TASK_PRIORITIES)[number];

export const taskSchema = z.object({
  title: z.string().trim().min(1, 'שדה חובה').max(200, 'עד 200 תווים'),
  description: z.string().trim().max(4000, 'עד 4000 תווים').optional(),
  status: z.enum(TASK_STATUSES),
  priority: z.enum(TASK_PRIORITIES).optional(),
  project_id: z.string().uuid().optional().or(z.literal('')),
  due_date: z.string().optional(),
});

export type TaskInput = z.infer<typeof taskSchema>;

/**
 * Hand-typed until `pnpm db:types` regenerates `database.types.ts`
 * against the live schema after migration 0005 lands.
 */
export interface TaskRow {
  id: string;
  organization_id: string;
  project_id: string | null;
  title: string;
  description: string | null;
  status: TaskStatus;
  priority: TaskPriority | null;
  assignee: string | null;
  due_date: string | null;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface TaskProjectOption {
  id: string;
  name: string;
}

export const TASK_PROJECT_FILTER_ALL = 'all';
export const TASK_PROJECT_FILTER_NONE = 'none';

/**
 * `'all'` shows every task; `'none'` shows only standalone tasks (project_id IS NULL);
 * any UUID string filters to that specific project.
 */
export interface TaskFilters {
  projectId: string;
  showCompleted: boolean;
}
